// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GoogleMapConfigurationStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import UiState from 'logic/Izenda.UiState';
import { observable, action } from 'mobx';
import GoogleMapConfiguration from './models/Izenda.GoogleMapConfiguration';
import AlertDetails from 'logic/models/Izenda.AlertDetails';
import fetcher from 'fetchers/Izenda.SystemSettingFetcher';

import { get } from 'lodash/fp';
export default class GoogleMapConfigurationStore {
  @observable googleMapConfiguration = new GoogleMapConfiguration();
  @observable alertDetails = new AlertDetails();

  noDirtyFnRegistration: false; // if true - we don't register dirty function in uiStore.
  dirtyFn = () => get('isDirty', this); // Dirty check function

  constructor(noDirtyFnRegistration: boolean) {
    this.noDirtyFnRegistration = !!noDirtyFnRegistration;
  }

  /**
   * Load Google Map configuration
   */
  loadGoogleMapConfiguration() {
    return fetcher.loadGoogleMapConfiguration(UiState.tenantId).then(
      action(result => {
        this.setGoogleApiKeyToUiState(result);
        this.googleMapConfiguration.populateData(result);
        this.resetDirty();
        this.alertDetails.reset();
        return result;
      })
    );
  }

  /**
   * Save Google Map configuration
   */
  saveGoogleMapConfiguration() {
    return fetcher.saveGoogleMapConfiguration(this.googleMapConfiguration.buildDataForSave()).then(result => {
      if (result.success) {
        const { googleAPIKeySetting } = result;
        this.setGoogleApiKeyToUiState(googleAPIKeySetting);
        this.googleMapConfiguration.populateData(googleAPIKeySetting);
        this.resetDirty();
      }
      return result;
    });
  }

  setGoogleApiKeyToUiState(result: any) {
    const googleApiKey = get('googleAPIKey', result);
    UiState.setGoogleApiKey(googleApiKey);
  }

  setGoogleMapValueByKey(key: string, value: any) {
    this.googleMapConfiguration.setValueByKey(key, value);
    this.isDirty = true;
  }

  /**
   * Reset dirty
   */
  resetDirty() {
    this.isDirty = false;
  }

  /**
   * Init Google map configuration store
   */
  init() {
    if (!this.noDirtyFnRegistration)
      UiState.setCheckDirtyFunction(this.dirtyFn);
  }

  /**
   * Destroy Google map configuration store
   */
  destroy() {
    if (!this.noDirtyFnRegistration)
      UiState.resetCheckDirtyFunction();
  }
}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.GoogleMapConfigurationStore.js